import controller from './projectWithAlipay.controller';
import template from './projectWithAlipay.html';

const ProjectWithAlipayDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default ProjectWithAlipayDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/projectWithAlipay/projectWithAlipay.component.js
 **/